import { validateRequiredFields } from "../../../../common/services/formHelpers";

export default values => {
    const requiredFields = {
        requestType: "Required",
        body: "Required",
    };
    const errors = validateRequiredFields(requiredFields, values);

    return errors;
};
